document.addEventListener("DOMContentLoaded", function () {
  // ========== 原有 header-move.js ==========
  function ensurePlaceholder() {
    let placeholder = document.getElementById("header-top-right-placeholder");
    if (!placeholder) {
      var headerBottom = document.querySelector(".header-bottom");
      if (headerBottom) {
        placeholder = document.createElement("div");
        placeholder.id = "header-top-right-placeholder";
        placeholder.className = "header-top-right-placeholder";
        headerBottom.appendChild(placeholder); // ← 插入 header-bottom 末端
      }
    }
    return placeholder;
  }

  var headerTop = document.querySelector(".header-top");
  var originalParent = headerTop || document.body;

  function moveHeaderTopRight() {
    var headerTopRight = document.querySelector(
      ".header-top--right.header__icons"
    );
    var headerTopRightGroup = document.querySelector(".header-top-right-group");
    if (headerTopRightGroup) headerTopRightGroup.style.marginBottom = "0px"; // 移除多餘的marginBottom
    var placeholder = ensurePlaceholder();
    if (window.innerWidth >= 768) {
      // 桌機，移到 placeholder
      if (
        headerTopRight &&
        placeholder &&
        !placeholder.contains(headerTopRight)
      ) {
        placeholder.appendChild(headerTopRight);
      }
      if (headerTop) {
        headerTop.style.paddingTop = "50px";
        headerTop.style.paddingBottom = "50px";
      }
    } else {
      // 手機，還原
      if (
        headerTopRight &&
        originalParent &&
        !originalParent.contains(headerTopRight)
      ) {
        originalParent.appendChild(headerTopRight);
        let ph = document.getElementById("header-top-right-placeholder");
        if (ph) ph.style.display = "";
      }
      if (headerTop) {
        headerTop.style.paddingTop = "";
        headerTop.style.paddingBottom = "";
      }
    }
  }
  moveHeaderTopRight();
  window.addEventListener("resize", moveHeaderTopRight);

  // ========== 捲動控制 header-top-right-placeholder 顯示/隱藏 ==========
  var mql = window.matchMedia("(min-width: 768px)");
  var wrapper =
    document.querySelector("sticky-header.header-wrapper") ||
    document.querySelector(".header-wrapper");
  var fixedRight = document.querySelector(".fixed-right");
  var placeholder = document.getElementById("header-top-right-placeholder");
  if (fixedRight) fixedRight.style.display = "none";

  function updateAtTopClass() {
    var scrollTop =
      window.pageYOffset || document.documentElement.scrollTop || 0;
    if (window.innerWidth < 768) {
      // 手機直接跳出，不控制
      return;
    }
    if (scrollTop <= 0) {
      // 頂端顯示
      if (placeholder) placeholder.style.display = "flex";
    } else {
      // 非頂端隱藏
      if (placeholder) placeholder.style.display = "none";
    }
  }

  function enableDesktopAtTop() {
    if (!wrapper) return;
    updateAtTopClass();
    window.addEventListener("scroll", updateAtTopClass, { passive: true });
  }
  function disableDesktopAtTop() {
    if (!wrapper) return;
    if (placeholder) placeholder.style.display = "";
    // if (fixedRight) fixedRight.style.display = "";
    window.removeEventListener("scroll", updateAtTopClass, { passive: true });
  }

  function handleBreakpointChange(e) {
    if (e.matches) {
      enableDesktopAtTop();
    } else {
      disableDesktopAtTop();
    }
  }

  handleBreakpointChange(mql);
  if (mql.addEventListener)
    mql.addEventListener("change", handleBreakpointChange);
  else mql.addListener(handleBreakpointChange);

  // ========== LOGO 移動（重點調整區） ==========
  var headerBottom = document.querySelector('.header-bottom');
  // 1. 尋找「含圖片」的 logo 區塊，通常是 .header__logo 或 .header__logo.header__logo_fixed
  // 建議優先用含 <img> 的那個
  var logo = document.querySelector('.header__logo img') 
    ? document.querySelector('.header__logo') 
    : document.querySelector('.header__logo.header__logo_fixed');
  var mainMenu = document.querySelector('.main-menu, .header__inline-menu');

  // 避免多次插入造成錯誤（每次 resize 只動一次）
  if (headerBottom && logo && mainMenu && headerBottom.firstChild !== logo) {
    // 如果 mainMenu 存在，插入 mainMenu 前
    headerBottom.insertBefore(logo, mainMenu);
  } else if (headerBottom && logo && headerBottom.firstChild !== logo) {
    // 若沒主選單，直接移到 header-bottom 最前面
    headerBottom.insertBefore(logo, headerBottom.firstChild);
  }
});